<template>
    <div 
        class="modal card row white ConfirmDialog"
        :class="{'top-bottom-fixed': !!topBottomFixed}" 
        ref="meuConfirm" 
        :style="width && `width: ${width}%;`"
    >
        <div class="col s12 pa-1">
            <div class="col s12 pa-0 valign-wrapper" :style="removeDisplayFlexTitle ? 'display: flex;align-items: center;justify-content: space-between;height: 1.8rem;' : ''">
                <div v-if="titleTruncate"
                    class="truncate truncateActive text-title"
                    :style="`font-size: ${sizeTitle};width: ${titleWidth}`"
                    v-html="title">
                </div>
                <div v-else class="text-title" :style="`font-size: ${sizeTitle};`" v-html="title"></div>
                <div class="col s12 m2 pa-0 right-align switch" v-if="switchComponent">
                    <label>
                        {{ switchOption1 }}
                        <input type="checkbox" ref="switchInput" v-model="inputSwitch" @change="$emit('onSwitch', inputSwitch)" />
                        <span class="lever"></span>
                        {{ switchOption2 }}
                    </label>
                </div>
                <div
                  v-if="!!titleBtn"
                  class="col s12 m3 pa-0 right-align switch"
                >
                   <a
                      href="#!"
                      class="modal-action waves-effect left ma-0 col s12 pa-0 center"
                      :class="{[`${titleBtnClass}`]: !!titleBtnClass}"
                      @click.prevent="$emit('onTitleBtn')">
                      {{titleBtn}}
                   </a>
                </div>
            </div>
        </div>
        <div class="divider col s12 pa-0" style="margin-bottom: 0.3px;">
          <top-loader :pilha="topLoader" />
        </div>
        <div
            class="modal-content"
            :class="{'centralized-content': centralizedContent, [modalContentClass]: modalContentClass}"
            style="height: calc(100% - 107px) !important;overflow-y: auto;padding: 1rem;"
        >
            <slot>
                <p>{{detail}}</p>
            </slot>
        </div>
        <div class="divider col s12 pa-0" style="z-index: 10;" v-if="btnCancel || btnConfirm"></div>
        <div class="col s12 pa-0">
            <a 
                v-if="btnCancel"
                href="#!"
                class="modal-action waves-effect btn-flat left ma-0 col s6 pa-0 center"
                :class="{'s6': !centralizedSingleBtn, 's12': centralizedSingleBtn && !(btnConfirm && btnCancel)}" 
                @click.prevent="cancelar">
                {{cancelLabel}}
            </a>
            <a 
                v-if="btnConfirm"
                href="#!" 
                class="modal-action waves-effect btn-flat right ma-0 col s6 pa-0 center"
                :class="{'s6': !centralizedSingleBtn, 's12': centralizedSingleBtn && !(btnConfirm && btnCancel)}" 
                @click.prevent="confirmar">
                {{confirmLabel}}
            </a>
        </div>
    </div>
</template>
<script>
import StHelper from '../../helpers/StHelper';
import TopLoader from '../topLoader/TopLoader.vue';
export default {
  components: { TopLoader },
    name:'confirm-dialog',
    props: {
        title:{type:String, required:false, default:'Atenção'},
        titleWidth:{type:String, required:false, default:'80%'},
        titleTruncate:{type:Boolean, required:false, default: false},
        titleBtn:{type:String, required:false, default:null},
        titleBtnClass:{type:String, required:false, default:'btn-flat'},
        confirmLabel:{type:String, required:false, default:'Confirmar'},
        btnConfirm: {type: Boolean, required: false, default:true},
        closeOnConfirm: {type: Boolean, required: false, default:true},
        cancelLabel:{type:String, required:false, default:'Cancelar'},
        btnCancel: {type: Boolean, required: false, default:true},
        closeOnCancel: {type: Boolean, required: false, default:true},
        detail:{type:String, required:false},
        show:{type:Boolean, required:true},
        width:{default: null},
        topBottomFixed:{type:Boolean, default: false},
        centralizedContent:{type:Boolean, default: false},
        centralizedSingleBtn:{type:Boolean, default: false}, // esta opção deve ser usada quando houver apenas um único botão no modal
        switchComponent:{type:Boolean, default:false},
        switchOption1:{type:String, required:false, default:'Sim'},
        switchOption2:{type:String, required:false, default:'Não'},
        switchInput:{type:Boolean, default:false},
        sizeTitle:{type:String, default:'24.6px;'},
        topLoader:{type:Array, default: ()=>[]},
        removeDisplayFlexTitle:{type:Boolean, default:false},
        modalContentClass:{type:String, required:false, default:''},
    },
    data() {
        return {
            inputSwitch: null,
        };
    },
    watch:{
        show:function(newValue) {
            if (newValue) {
                $(this.$refs.meuConfirm).modal('open');
            } else {
                $(this.$refs.meuConfirm).modal('close');
            }
        },
    },
    updated() {
        StHelper.truncateActive();
    },
    created() {
        this.inputSwitch = this.switchInput;
    },
    methods:{
        confirmar() {
            this.$emit('onConfirm');
            if (this.closeOnConfirm) {
                this.$emit('onClose');
            }
        },
        cancelar() {
            this.$emit('onCancel');
            if (this.closeOnCancel) {
                this.$emit('onClose');
            }
        }
    },
    mounted(){
        $(this.$refs.meuConfirm).modal({
            dismissible: false
        });
        StHelper.truncateActive();
    }
}

</script>

<style lang="scss" scoped>

	.top-bottom-fixed {
        width: 70%;
        height: 58vh;
        max-height: 80vh;

        .divider:first-child {
            margin-bottom: 1px;
        }
    }

    .centralized-content {
        display: flex;
        justify-content: center;
        align-items: center;
    }

	@media only screen and (max-width: 600px) {
		.top-bottom-fixed {
            width: 95% !important;
           
            .modal-content{
				height: calc(100% - 97px) !important;
                padding: 1rem;
            }

			.modal-footer{
                padding: 1rem;
            }
		}

		.modal {
		    top: initial;
		    width: 95% !important;
            max-height: 86% !important;
		}

		.text-title {
            font-size: initial !important;
        }
	}
</style>


// WEBPACK FOOTER //
// ConfirmDialog.vue?a5bbedaa